import {
  UseMutationOptions,
  UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  CommissionModel,
  CommissionMutationInput,
  CommissionMutationUpdateInput,
} from './model';

const ENDPOINT = 'commission-masters';

export function useCreateCommission(
  options?: UseMutationOptions<
    ApiResult<CommissionModel>,
    ApiError,
    CommissionMutationInput
  >,
): UseMutationResult<
  ApiResult<CommissionModel>,
  ApiError,
  CommissionMutationInput
> {
  return useMutation<
    ApiResult<CommissionModel>,
    ApiError,
    CommissionMutationInput
  >(async function (body) {
    return MutationFetchFunction({
      method: 'POST',
      url: `${ENDPOINT}`,
      body,
      classType: CommissionModel,
    });
  }, options);
}

export function useUpdateCommission(
  options?: UseMutationOptions<
    ApiResult<CommissionModel>,
    ApiError,
    CommissionMutationUpdateInput
  >,
): UseMutationResult<
  ApiResult<CommissionModel>,
  ApiError,
  CommissionMutationUpdateInput
> {
  return useMutation<
    ApiResult<CommissionModel>,
    ApiError,
    CommissionMutationUpdateInput
  >(async function (body) {
    return MutationFetchFunction({
      method: 'PUT',
      url: `${ENDPOINT}/${body.id}`,
      body: body.body,
      classType: CommissionModel,
    });
  }, options);
}
